import { BaseEvent } from '../../../../../domain/event/base-event';
export class FieldEvent extends BaseEvent {
    constructor({ subject, type, payload, metadata, fromPersistence, }) {
        metadata = {
            aggregatename: 'Field',
            ...metadata,
        };
        super({
            subject,
            type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
//# sourceMappingURL=field.event.js.map